import cx from 'classnames';
import Button from 'govbr.frontend.policy/components/Button';
import PropTypes from 'prop-types';

const ButtonBody = (props) => {
  const { data, isEditMode } = props;
  const {
    label,
    href,
    type = 'primary',
    size = 'default',
    align = 'center',
    icon,
    isCircle = false,
    inverted,
  } = data;

  const hasLink = href?.[0];

  const hasRequiredAttributes = label && hasLink;
  const showPlaceholder = isEditMode && !hasRequiredAttributes;

  if (!isEditMode && !hasRequiredAttributes) {
    return null;
  }

  const classesContainer = cx('mb-4', `text-${align}`);

  return (
    <div className={classesContainer}>
      <Button
        label={label}
        link={href?.[0]?.['@id']}
        variant={type}
        size={size}
        inverted={inverted}
        icon={icon}
        isCircle={isCircle}
        isEditMode={isEditMode}
        showPlaceholder={showPlaceholder}
      />
    </div>
  );
};

ButtonBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default ButtonBody;
